function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawDroneDelivery = function UndrawDroneDelivery(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 958.98 717.78",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 768.34,
    y1: 226.6,
    x2: 768.34,
    y2: 91.11,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 324.42,
    y1: 444.93,
    x2: 324.42,
    y2: 444.59,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 437.75,
    y1: 743.35,
    x2: 437.75,
    y2: 288.01,
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.25,
    d: "M910 277.53v-64h-38v64h-45v-99h-33v-74h-27v-76h-56v76h-27v74h-32v-89h-18v-45h-11v45h-64v284h-49v-30h-30v30h-49v-96h-88v-64h-38v64h-2v123h-40v-72h-48v72h-40v-222h-31v-74H30v74H0v391h955v-292h-45z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M19 201.53h42v24H19zM155 225.53h-42v-24h42zM19 248.53h42v24H19zM155 272.53h-42v-24h42zM19 295.53h42v24H19zM155 319.53h-42v-24h42zM19 342.53h42v24H19zM155 366.53h-42v-24h42zM19 389.53h42v24H19zM155 413.53h-42v-24h42zM19 436.53h42v24H19zM155 460.53h-42v-24h42zM19 483.53h42v24H19zM155 507.53h-42v-24h42zM190 424.53h98v12h-98zM190 442.53h98v12h-98zM190 460.53h98v12h-98zM446 430.53h98v12h-98zM446 448.53h98v12h-98zM446 466.53h98v12h-98zM190 478.53h98v12h-98zM190 496.53h98v12h-98zM190 514.53h98v12h-98zM324 300.53h27v35h-27zM410 335.53h-27v-35h27zM324 356.53h27v35h-27zM410 391.53h-27v-35h27zM324 412.53h27v35h-27zM410 447.53h-27v-35h27zM324 468.53h27v35h-27zM410 503.53h-27v-35h27zM559 112.53h36v46h-36zM559 178.53h36v46h-36zM559 244.53h36v46h-36zM559 310.53h36v46h-36zM559 376.53h36v46h-36zM559 442.53h36v46h-36zM672.5 206.53h134v39h-134zM673 290.53h134v39H673zM673.5 374.53h134v39h-134zM674 458.53h134v39H674zM30 125.53h18v38H30zM910 300.53h45v58h-45zM910 384.53h45v58h-45zM910 468.53h45v58h-45z"
  }), React.createElement("path", {
    d: "M264.68 76.21h-6.88a4.82 4.82 0 1 0 0-9.63h-55.73a4.82 4.82 0 0 0 0 9.63h6.88a4.82 4.82 0 1 0 0 9.63h-9.63a4.82 4.82 0 0 0 0 9.63h55.73a4.82 4.82 0 0 0 0-9.63h9.63a4.82 4.82 0 1 0 0-9.63zM510.68 197.21h-6.88a4.82 4.82 0 1 0 0-9.63h-55.73a4.82 4.82 0 0 0 0 9.63h6.88a4.82 4.82 0 1 0 0 9.63h-9.63a4.82 4.82 0 1 0 0 9.63h55.73a4.82 4.82 0 1 0 0-9.63h9.63a4.82 4.82 0 1 0 0-9.63zM929.68 39.21h-6.88a4.82 4.82 0 1 0 0-9.63h-55.73a4.82 4.82 0 0 0 0 9.63h6.88a4.82 4.82 0 1 0 0 9.63h-9.63a4.82 4.82 0 1 0 0 9.63h55.73a4.82 4.82 0 1 0 0-9.63h9.63a4.82 4.82 0 1 0 0-9.63z",
    fill: "#252223",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M918.56 95.65a181.12 181.12 0 0 0-25.21 1.52 6 6 0 0 0-12.1 0 181.12 181.12 0 0 0-25.21-1.52c-18.65 0-33.78 2-33.78 4.54s15.12 4.54 33.78 4.54a181.12 181.12 0 0 0 25.21-1.52 6 6 0 0 0 .39 2.13 4 4 0 0 0-.4 6.53 11.17 11.17 0 0 0-6.63 6.1 10.33 10.33 0 0 0-5.8-2.11l-62.81-2.8a24.54 24.54 0 0 0-19.67-9.85h-39.54a24.54 24.54 0 0 0-19.78 10l-59.66 2.67a10.33 10.33 0 0 0-5.43 1.83 11.17 11.17 0 0 0-5.81-5.58 4 4 0 0 0-.95-7.19 6 6 0 0 0 .25-1.73 181.11 181.11 0 0 0 25.21 1.52c18.65 0 33.78-2 33.78-4.54s-15.12-4.54-33.78-4.54a181.12 181.12 0 0 0-25.21 1.52 6 6 0 0 0-6-6 6 6 0 0 0-6 6 181.12 181.12 0 0 0-25.21-1.52c-18.65 0-33.78 2-33.78 4.54s15.12 4.54 33.78 4.54a181.12 181.12 0 0 0 25.21-1.52 6 6 0 0 0 .39 2.13 4 4 0 0 0-.24 6.66 11.14 11.14 0 0 0-7.21 10.41v7.46A11.14 11.14 0 0 0 647.4 141h4.43a11.11 11.11 0 0 0 8.93-4.5 10.33 10.33 0 0 0 6.76 2.77l58.5 1.64a24.7 24.7 0 0 0 7.25 7.39c-5.6 5.69-27.44 30.92-23.92 75.38 0 0 3.53 6.55 12.6 0 0 0-5.8-49.54 26.67-69.94a8.06 8.06 0 0 0 7.61 5.41h4.15a21.68 21.68 0 1 0 15.91 0h4.15a8.06 8.06 0 0 0 7.61-5.41c32.47 20.4 26.67 69.94 26.67 69.94 9.07 6.55 12.6 0 12.6 0 4-50.92-25.21-76.62-25.21-76.62h-.53a24.7 24.7 0 0 0 5.48-6.06l61.58-1.72a10.34 10.34 0 0 0 7.05-3 11.12 11.12 0 0 0 9.14 4.78h4.43a11.14 11.14 0 0 0 11.14-11.14v-7.46a11.14 11.14 0 0 0-6.6-10.17 4 4 0 0 0-.72-7.31 6 6 0 0 0 .25-1.73 181.11 181.11 0 0 0 25.21 1.52c18.65 0 33.78-2 33.78-4.54s-15.1-4.58-33.76-4.58z",
    transform: "translate(-120.51 -91.11)",
    fill: "url(#prefix__a)"
  }), React.createElement("circle", {
    cx: 647.83,
    cy: 87.06,
    r: 20.44,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 647.83,
    cy: 87.06,
    r: 13.79,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 647.83,
    cy: 87.06,
    r: 13.79,
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("circle", {
    cx: 647.83,
    cy: 87.06,
    r: 9.03,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 647.83,
    cy: 87.06,
    r: 9.03,
    opacity: 0.25
  }), React.createElement("path", {
    d: "M615.97 56.63s-27.57 24.26-23.77 72.26c0 0 3.33 6.18 11.89 0 0 0-7.13-60.86 40.41-72.27zM679.68 56.63s27.58 24.26 23.81 72.26c0 0-3.33 6.18-11.89 0 0 0 7.13-60.86-40.41-72.27z",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 604.32,
    y: 15.26,
    width: 83.68,
    height: 46.36,
    rx: 23.18,
    ry: 23.18,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M618.03 51.11l-65.29-1.83a9.79 9.79 0 0 1-9.52-9.79v-2.5a9.79 9.79 0 0 1 9.35-9.78l65.29-2.93a9.79 9.79 0 0 1 10.23 9.78v7.27a9.79 9.79 0 0 1-10.06 9.78zM677.15 51.11l65.29-1.83a9.79 9.79 0 0 0 9.52-9.79v-2.5a9.79 9.79 0 0 0-9.35-9.78l-65.29-2.93a9.79 9.79 0 0 0-10.23 9.78v7.27a9.79 9.79 0 0 0 10.06 9.78z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M618.03 51.11l-65.29-1.83a9.79 9.79 0 0 1-9.52-9.79v-2.5a9.79 9.79 0 0 1 9.35-9.78l65.29-2.93a9.79 9.79 0 0 1 10.23 9.78v7.27a9.79 9.79 0 0 1-10.06 9.78zM677.15 51.11l65.29-1.83a9.79 9.79 0 0 0 9.52-9.79v-2.5a9.79 9.79 0 0 0-9.35-9.78l-65.29-2.93a9.79 9.79 0 0 0-10.23 9.78v7.27a9.79 9.79 0 0 0 10.06 9.78z",
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("rect", {
    x: 523.26,
    y: 22.87,
    width: 25.2,
    height: 28.05,
    rx: 11.17,
    ry: 11.17,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 747.2,
    y: 22.87,
    width: 25.2,
    height: 28.05,
    rx: 11.17,
    ry: 11.17,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 528.49,
    y: 16.69,
    width: 15.21,
    height: 7.61,
    rx: 3.8,
    ry: 3.8,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 529.92,
    y: 3.85,
    width: 11.41,
    height: 17.12,
    rx: 5.71,
    ry: 5.71,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 506.14,
    cy: 12.41,
    rx: 31.86,
    ry: 4.28,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 565.1,
    cy: 12.41,
    rx: 31.86,
    ry: 4.28,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 752.9,
    y: 16.69,
    width: 15.21,
    height: 7.61,
    rx: 3.8,
    ry: 3.8,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 754.33,
    y: 3.85,
    width: 11.41,
    height: 17.12,
    rx: 5.71,
    ry: 5.71,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 730.56,
    cy: 12.41,
    rx: 31.86,
    ry: 4.28,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 789.51,
    cy: 12.41,
    rx: 31.86,
    ry: 4.28,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 506.14,
    cy: 12.41,
    rx: 31.86,
    ry: 4.28,
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 565.1,
    cy: 12.41,
    rx: 31.86,
    ry: 4.28,
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 730.56,
    cy: 12.41,
    rx: 31.86,
    ry: 4.28,
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 789.51,
    cy: 12.41,
    rx: 31.86,
    ry: 4.28,
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("rect", {
    x: 628.81,
    y: 52.82,
    width: 38.04,
    height: 15.21,
    rx: 7.61,
    ry: 7.61,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 628.81,
    y: 52.82,
    width: 38.04,
    height: 15.21,
    rx: 7.61,
    ry: 7.61,
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("path", {
    fill: "#67647e",
    d: "M682.36 131.85h-84.71v84.71H704v-84.71h-21.64z"
  }), React.createElement("path", {
    opacity: 0.25,
    d: "M682.36 131.85h21.65v84.71h-21.65zM608 145.97h16v8.47h-16z"
  }), React.createElement("path", {
    d: "M643.94 121.89c3.6 5.1 3 11.67 3 11.67s-6.38-1.69-10-6.79-5-10.32-3-11.67 6.4 1.68 10 6.79z",
    fill: "#67647e"
  }), React.createElement("path", {
    d: "M650.03 121.89c-3.6 5.1-3 11.67-3 11.67s6.38-1.69 10-6.79 5-10.32 3-11.67-6.4 1.68-10 6.79z",
    fill: "#67647e"
  }), React.createElement("path", {
    d: "M324.48 444.59l-.11.34a2 2 0 0 0 .11-.34z",
    transform: "translate(-120.51 -91.11)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M646.39 721.2c.07-.1.14-.19.19-.29l.11-.21c.05-.1.11-.19.15-.29l.08-.21c0-.1.08-.2.11-.3s0-.13.05-.2.05-.2.07-.31 0-.12 0-.19v-.32-.17-.33-.15V717.76c0-.12 0-.24-.08-.36v-.11c0-.13-.08-.25-.12-.38v-.08q-.07-.2-.16-.39v-.06q-.09-.21-.2-.41l-.24-.43a14.8 14.8 0 0 0-3.43-3.72c-10.31 4.25-23-.61-23-.61s-17-8.49-15.77-6.07c.41.82.2 2.45-.26 4.27-8.14-1.71-12.63-6.08-15.07-10l9.27-10s-37.61-21.23-41.85-32.15-24.87-41.85-24.87-41.85-6.67-24.26-18.8-29.72c0 0-24.19-28.9-38.32-53.68 5-12.49 12-32 10.42-40.33-2-10.38.07-30 .9-36.94 6.71 5.6 34 27.77 44.59 27.24 3.81-.19 7.91-2.23 11.76-4.95 9.16-5.8 17.36-16.28 17.36-16.28-1.24.12-2.25-1-3.07-2.9 10.13-11 31.11-33.64 33.4-34.1 3-.61 19.41-29.11 10.31-35.18s-25.47 15.77-26.08 20c-.41 2.88-13.1 15.52-21.22 23.36v-.31l-1.2.6v-.6l-20.95 10.47-17.87-24.42s-4.85-26.08-17-30.33S474.48 370 474.48 370a12.49 12.49 0 0 0-.27 1.29c-.61-.81-.94-1.29-.94-1.29s0 .11-.08.29a31.91 31.91 0 0 1-.69-11.42l.17-.1c.07-.47.15-.92.23-1.35a30.35 30.35 0 0 0 12.29-37.59c3.09-2.16 7.57-3.5 11.38-5.14a33.38 33.38 0 0 0 13.69-10.35 12.07 12.07 0 0 0-6.34.13c-.26-2.81 3-6 .46-8.14-1.56-1.33-4.47-1.21-6.69-.55s-4.25 1.74-6.61 2c-4.11.5-8-1.49-10.93-3.64s-5.69-4.67-9.61-5.69c-7.79-2-15.51 2.61-23.33 4.57-12.56 3.14-20 6.5-20.61 14.5a26 26 0 0 0-4.44 3.77 16.55 16.55 0 0 0-5.32 9c-1.06 5.44 1.14 11 3.8 15.84 1.51 2.77 8.77 17.12 13.7 15.23a30.5 30.5 0 0 0 4.54 4.25c-.16 1.65-.39 3.32-.65 5a11.28 11.28 0 0 1-3.57 1.23 42.93 42.93 0 0 1-8.23.72 120.44 120.44 0 0 1-12.91-.79 109 109 0 0 0-12.55-.72 61.25 61.25 0 0 0-6.26.3h-.32l-1.24.15h-.19l-1.35.22h-.15l-1.1.22-.25.05-1.12.27-1.1.31-.18.05-.86.27-.19.06c-.65.22-1.26.46-1.84.7l-.18.08-.72.31-.13.06-.81.38h-.07l-.7.35-.17.09-.68.35-.86.45-.52.27-.24.13-.71.36c-6.07 3-64.9 18.8-75.21 50.34l.21.19.23.21c-.17.46-.34.92-.49 1.38 0 0 1 .9 2.56 2.36-2.77 12.06-10.19 42.88-14.09 44.34-4.85 1.82-10.31 38.82 2.43 37.61s12.74-30.93 12.74-30.93 8.4-22.52 14.59-33.95a15.94 15.94 0 0 1 2.43 4.71v.13-.12a3.41 3.41 0 0 1 .07 1.6c.6-1.76 3.71-9.84 10.2-8.76 6.93 1.16 33.11-24.63 35.59-27.1-.06.67-.14 1.51-.22 2.48 0 .57-.1 1.18-.15 1.84v2.88l-.05.75v4.23l-.07 1.1v.15l-.06 1V425.73l-.05 1v.2q0 .65-.06 1.31v.08q0 .6-.05 1.2v3.09q0 1.37-.09 2.77v10.64c0 13.23.81 26.7 3.78 34.38a37.78 37.78 0 0 1 2.48 12.92 52.73 52.73 0 0 1-6.12 22.87l.71-.22-.13.23.39-.12c-.6 1.25-1 1.94-1 1.94s.88-.28 2.45-.74c-2.24 7.9-3.73 20.06.58 35.32 0 0 2.43 13.34.61 18.2s-3.64 43.67-3.64 43.67-3.64 4.85-10.31 1.82-88.55-13.34-88.55-13.34-.19.33-.51.92c-2.52-.79-6.15-2-8.8-3.11 1-1.38 1.89-2.17 2.64-2.06 0 0-4.37-2.11-9.13-3.78l-.87-.3-.85-.28h-.06l-.81-.25h-.09l-.74-.21h-.15l-.7-.18h-.18l-.67-.15h-.19l-.6-.12h-.23l-.54-.09H248l-.49-.06H245.24l-.33.07h-.22l-.28.1-.2.07a2.36 2.36 0 0 0-.26.15l-.15.09a1.88 1.88 0 0 0-.33.31c-3 3.64-20 73.39-12.13 78.24l.68.41.28.16.36.2.35.18.25.13.38.18.19.09.39.17.14.06.4.15h.09l.41.13h.05c4.4 1.19 5.86-2.88 11.19-11.6 5.22-8.54 11.93-19.31 17.79-23.3.13.29.26.58.4.86 0 0 61.26 6.67 83.7 14s40 17 54.59 0c13.06-15.23 26.11-64.62 28.66-74.63l.38-1.5v-.26l48.52 37 21.23 24.87s29.72 41.85 35.18 42.46S567 722.73 567 722.73l.92-1c.22 1.11.39 2.13.52 3-2 4.81-.15 10.61 1.67 14.43l.08.16.21.42.11.22.2.39.1.19.21.4.11.19.16.29.08.15.21.36.09.15.13.21.07.12.16.26.06.1.1.15v.07l.1.16.06.08s63.69-15.16 71.57-20c.25-.15.48-.31.7-.47l.2-.16.4-.32.2-.19.31-.29.18-.21.24-.28z",
    transform: "translate(-120.51 -91.11)",
    fill: "url(#prefix__c)"
  }), React.createElement("path", {
    d: "M155.99 511.63s-14.18-4.14-14.77-5.91-12.41 32.49-12.41 32.49l11.82 8.27s12.41-7.09 18.91-5.91-3.55-28.94-3.55-28.94zM461.43 596.11s1.77 16 21.27 17.72-13 16-13 16l-24.81 1.77s-.59-10-4.73-17.72 21.27-17.77 21.27-17.77z",
    fill: "#4c4c56"
  }), React.createElement("path", {
    d: "M256.43 416.51s-11.22 17.13-3.54 44.31c0 0 2.36 13 .59 17.72s-3.54 42.54-3.54 42.54-3.54 4.73-10 1.77-86.25-13-86.25-13-13 22.45-5.91 36c0 0 59.67 6.5 81.53 13.59s39 16.54 53.17 0S310.84 485 310.84 485l47.26 36 20.68 24.22s28.95 40.76 34.27 41.35 30.13 39.58 30.13 39.58l30.13-32.49s-36.69-20.59-40.82-31.23-24.22-40.76-24.22-40.76-6.5-23.63-18.31-28.95c0 0-42.54-50.81-46.67-74.44s-70.91-12.39-70.91-12.39z",
    fill: "#5f5d7e"
  }), React.createElement("path", {
    d: "M476.2 620.89s4.14-9.45 3-11.82 15.29 5.94 15.29 5.94 12.41 4.73 22.45.59c0 0 8.86 6.5 1.18 11.22s-69.71 19.5-69.71 19.5-9.45-13.59-1.77-21.27z",
    fill: "#986365"
  }), React.createElement("path", {
    d: "M432.49 562.43c-4.14-10.63-24.22-40.76-24.22-40.76s-6.5-23.63-18.31-28.95c0 0-42.54-50.81-46.67-74.44-.85-4.87-4.37-8.26-9.41-10.57l-8.24 24.75-11.25 33.8c-2.17 6.52-4.23 13.79-4 20.53.29-1.12.44-1.74.44-1.74l47.26 36 20.68 24.22s28.95 40.76 34.27 41.35 30.13 39.58 30.13 39.58l30.13-32.49s-36.68-20.64-40.81-31.28z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M352.72 264.68s-5 12.7 1.48 24.52-2.66 32.79-8.57 34-29.54-14.18-31.31-24.22 7.68-30.72 3-44.31z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M320.82 286.54s18.31 37.22 38.4 10.63c0 0 20.09 40.76 13.59 47.26a136.22 136.22 0 0 1-14.77 12.46l-10.63 74.44s-60.26-20.68-85.66-17.13l39-93.34z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M320.82 284.77s18.31 37.22 38.4 10.63c0 0 20.09 40.76 13.59 47.26a136.22 136.22 0 0 1-14.77 12.41l-10.63 74.44s-60.26-20.68-85.66-17.13l39-93.34z",
    fill: "#d39999"
  }), React.createElement("path", {
    d: "M190.26 327.89s-10 46.08-14.77 47.85-10 37.81 2.36 36.63 12.41-30.13 12.41-30.13 13-34.86 18.31-39-18.31-15.35-18.31-15.35zM422.44 349.16s26.59-24.81 27.18-28.95 16.54-25.4 25.4-19.5-7.09 33.67-10 34.27-37.81 39-37.81 39z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M318.16 275.02s-3.25 3.84-25.11 1.48-27.18 1.77-33.08 4.73-63.21 18.31-73.26 49c0 0 22.45 20.09 20.09 25.4 0 0 3-10 10-8.86s34.86-26.59 34.86-26.59-5.32 52 1.77 70.3-3.54 36.63-3.54 36.63 50.22-16 72.67-8.27c0 0 13-58.49 1.77-82.12s4.73-46.08 4.73-46.08z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M318.75 273.25s-3.25 3.84-25.11 1.48-27.18 1.77-33.08 4.73-63.21 18.31-73.26 49c0 0 22.45 20.09 20.09 25.4 0 0 3-10 10-8.86s34.86-26.59 34.86-26.59-5.32 52 1.77 70.3-3.53 36.66-3.53 36.66 50.22-16 72.67-8.27c0 0 13-58.49 1.77-82.12s4.75-46.09 4.75-46.09z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M318.16 273.25s-3.25 3.84-25.11 1.48-27.18 1.77-33.08 4.73-63.21 18.31-73.26 49c0 0 22.45 20.09 20.09 25.4 0 0 3-10 10-8.86s34.86-26.59 34.86-26.59-5.32 52 1.77 70.3-3.54 36.63-3.54 36.63 50.22-16 72.67-8.27c0 0 13-58.49 1.77-82.12s4.76-46.06 4.76-46.06z",
    fill: "#ec7580"
  }), React.createElement("path", {
    d: "M351.25 283.89s8.57 12.7 20.38 16.84 16.54 29.54 16.54 29.54l17.72 24.22 21.27-10.6s.59 28.95 6.5 28.36c0 0-14.77 18.91-26.59 19.5s-44.89-27.86-44.89-27.86-3.54 26-1.18 38.4-14.77 50.22-14.77 50.22l-23.63-4.73s12.41-47.26 27.77-54.94c0 0 0-31.9-2.36-39.58s15.36-36.63 13-42.54c-1.33-3.31-6.53-10.4-9.16-16.84a16.85 16.85 0 0 1-.6-9.99z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M353.02 282.7s8.57 12.7 20.38 16.84 16.54 29.54 16.54 29.54l17.72 24.22 21.27-10.63s.59 28.95 6.5 28.36c0 0-14.77 18.91-26.59 19.5s-44.9-27.77-44.9-27.77-3.54 26-1.18 38.4-14.77 50.22-14.77 50.22l-23.63-4.73s12.41-47.26 27.77-54.94c0 0 0-31.9-2.36-39.58s15.36-36.63 13-42.54c-1.33-3.31-6.53-10.4-9.16-16.84a16.85 16.85 0 0 1-.59-10.05z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M351.84 282.7s8.57 12.7 20.38 16.84 16.54 29.54 16.54 29.54l17.73 24.22 21.27-10.63s.59 28.95 6.5 28.36c0 0-14.77 18.91-26.59 19.5s-44.9-27.77-44.9-27.77-3.54 26-1.18 38.4-14.77 50.22-14.77 50.22l-23.63-4.73s12.41-47.26 27.77-54.94c0 0 0-31.9-2.36-39.58s15.36-36.63 13-42.54c-1.33-3.31-6.53-10.4-9.16-16.84a16.85 16.85 0 0 1-.6-10.05z",
    fill: "#ec7580"
  }), React.createElement("path", {
    d: "M352.84 283.7s8.57 12.7 20.38 16.84 16.54 29.54 16.54 29.54l17.73 24.22 21.27-10.63s.59 28.95 6.5 28.36c0 0-14.77 18.91-26.59 19.5s-44.9-27.77-44.9-27.77-3.54 26-1.18 38.4-14.77 50.22-14.77 50.22l-23.63-4.73s12.41-47.26 27.77-54.94c0 0 0-31.9-2.36-39.58s15.36-36.63 13-42.54c-1.33-3.31-6.53-10.4-9.16-16.84a16.85 16.85 0 0 1-.6-10.05z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M147.13 505.72s-17.13-8.27-20.09-4.73-19.5 71.48-11.82 76.21 8.27 1.18 14.77-9.45 15.36-24.81 21.86-24.22c0 0-18.91-6.5-18.31-8.86s9.46-29.54 13.59-28.95z",
    fill: "#986365"
  }), React.createElement("path", {
    d: "M318.35 269.89a29.53 29.53 0 0 0 32.92 1.85 29.93 29.93 0 0 1 1.46-5.9l-35.45-10c1.46 4.17 1.56 9.05 1.07 14.05z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M340.27 246.78c7.2.62 16-.73 18.65-5.63.77-1.41.93-3 1.71-4.37 2.26-4.06 8.72-5.72 13.91-8a32.51 32.51 0 0 0 13.33-10.08 11.76 11.76 0 0 0-6.18.13c-.25-2.73 2.9-5.85.45-7.93-1.52-1.29-4.35-1.17-6.52-.53s-4.13 1.69-6.44 2c-4 .49-7.79-1.45-10.65-3.55s-5.54-4.55-9.36-5.54c-7.58-2-15.11 2.55-22.72 4.45-15.61 3.91-23.18 8.15-18.94 21.72 3.14 10.05 19.66 16.2 32.76 17.33z",
    fill: "#865a61"
  }), React.createElement("circle", {
    cx: 336.18,
    cy: 245.18,
    r: 29.54,
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M313.22 240.68c1.43-5.8 5.56-11.21 11.31-12.82 4.89-1.37 10.09.12 14.87 1.85s9.65 3.75 14.72 3.45 10.39-3.8 10.77-8.86a4.24 4.24 0 0 0-.37-2.29 5.63 5.63 0 0 0-2.11-2c-7.43-4.74-15.88-8.47-24.69-8.33-7.25.12-14.18 2.84-20.92 5.52-8.5 3.38-18.17 8.11-19.92 17.09-1 5.3 1.11 10.69 3.7 15.43 1.5 2.74 8.76 17.12 13.56 14.75 1.94-.92-1.84-20.07-.92-23.79z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M314.4 239.5c1.43-5.8 5.56-11.21 11.31-12.82 4.89-1.37 10.09.12 14.87 1.85s9.65 3.75 14.72 3.45 10.39-3.8 10.77-8.86a4.24 4.24 0 0 0-.37-2.29 5.63 5.63 0 0 0-2.11-2c-7.43-4.74-15.88-8.47-24.69-8.33-7.25.12-14.18 2.84-20.92 5.52-8.5 3.38-18.17 8.11-19.92 17.09-1 5.3 1.11 10.69 3.7 15.43 1.5 2.74 8.76 17.12 13.56 14.75 1.94-.92-1.83-20.07-.92-23.79z",
    fill: "#865a61"
  }), React.createElement("path", {
    d: "M117 577.8c-7.68-4.73 8.86-72.67 11.82-76.21 1.29-1.55 5.31-.84 9.42.46-4.66-1.63-9.71-2.83-11.19-1-3 3.54-19.5 71.48-11.82 76.21a13.93 13.93 0 0 0 4.28 1.95 21.65 21.65 0 0 1-2.51-1.41zM520.3 619.23c.8 2 .56 4.39-2.75 6.42-7.68 4.73-69.71 19.5-69.71 19.5a29.62 29.62 0 0 1-1.69-2.87 31.57 31.57 0 0 0 2.28 4.05s62-14.77 69.71-19.5c3.97-2.44 3.52-5.36 2.16-7.6z",
    fill: "#fff",
    opacity: 0.5
  }), React.createElement("g", {
    opacity: 0.05
  }, React.createElement("path", {
    d: "M209.96 347.97c-4.91-7.9-18.47-20.08-18.47-20.08 10-30.72 67.35-46.08 73.26-49 3.26-1.63 6.34-3.62 12.12-4.68-9 .66-12.79 3.24-16.84 5.27-5.91 3-63.21 18.31-73.26 49 0 0 21.58 19.31 20.19 25.07a18.49 18.49 0 0 1 3-5.58zM206.91 353.56l-.11.33a1.91 1.91 0 0 0 .11-.33zM318.84 274.22l-.68-1s-.75.88-3.93 1.54a34.47 34.47 0 0 0 4.61-.54zM217.49 345.06a7.88 7.88 0 0 0 2.58-.7 6.42 6.42 0 0 0-2.58.7zM294.35 415.77c10.57-1.16 20.89-1.18 28.24 1.33 0 0 .14-.62.37-1.73-8.06-1.57-18.41-1.02-28.61.4zM255.17 423.82c2-4 9.17-19.82 3-35.67-7.09-18.31-1.77-70.3-1.77-70.3s-2 2-5.12 5c-1.09 12.89-3.67 50.84 2.17 65.93 7.09 18.31-3.54 36.63-3.54 36.63s1.97-.66 5.26-1.59z"
  })), React.createElement("path", {
    d: "M784.57 615.23c-7.12 3.67-14.58 6.84-21.94 10-27.19 11.48-54.79 23.06-84 27-54.82 7.39-111.44-12.62-165.33-.17-45.15 10.42-82.49 42.35-126.6 56.57-20.51 6.61-41.85 9.2-63.38 9.2h-2.83q-4-.05-7.94-.2c-21.83-.82-43.75-4.05-65.15-8.18-67.57-13-136.34-36.83-188-80.7 150.43-27.53 460.28-69.71 725.17-13.52z",
    fill: "#252223",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M624.97 443.61s19.42 19.42 8.46 48.24 18.8 76.75 18.8 76.75l-.91-.15c-39.89-7-59.71-52.66-37.53-86.55 8.24-12.61 15.01-27.39 11.18-38.29z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M624.97 443.61s11 23.81 0 43.23-1.88 73.93 27.25 81.76",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M590.38 522.16s22.16-3.53 24.18 16.33 42.62 22.61 42.62 22.61l-.76.51c-33.52 22-65.56 14-60.73-15.2 1.8-10.86 1.64-21.77-5.31-24.25z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M590.38 522.16s22.16-3.53 24.18 16.33 42.62 22.61 42.62 22.61l-.76.51c-33.52 22-65.56 14-60.73-15.2 1.8-10.86 1.64-21.77-5.31-24.25z",
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M590.38 522.16s17.2 3.78 15.79 19.42 25.55 34.39 51 19.53",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M675.09 564.89s-13.94-2.79-17.65-6.5-20.44-10.22-22.3-5.57-25.09 20.44-9.29 23.23 37.17 3.72 41.81 1.86 7.43-13.02 7.43-13.02z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M625.84 574.31c15.8 2.79 37.17 3.72 41.81 1.86 3.54-1.42 6-8.21 7-11.38l.46.1s-2.79 11.15-7.43 13-26 .93-41.81-1.86c-4.56-.8-5.86-2.69-5.37-5.09.36 1.57 1.99 2.77 5.34 3.37z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M927.75 588.89s13.21-44.87-2.48-77.89a70.87 70.87 0 0 1-5.73-44.46 119.19 119.19 0 0 1 6.29-20.87",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M916.07 424.77c0 5.5 10 21.44 10 21.44s10-15.95 10-21.44a10 10 0 0 0-19.91 0zM899.61 455.23c3 4.62 20 12.59 20 12.59s-.31-18.8-3.3-23.41a10 10 0 0 0-16.72 10.82zM900.33 507.28c4.91 2.48 23.63.77 23.63.77s-9.76-16.07-14.67-18.55a10 10 0 1 0-9 17.78zM909.74 546.54c4.42 3.27 23.16 4.75 23.16 4.75s-6.9-17.49-11.32-20.76a10 10 0 0 0-11.84 16zM940.49 468.89c-3.94 3.83-22.32 7.8-22.32 7.8s4.5-18.25 8.44-22.08a10 10 0 0 1 13.88 14.28zM950.95 514.94c-4.91 2.48-23.63.77-23.63.77s9.76-16.07 14.67-18.55a10 10 0 1 1 9 17.78zM954.94 561.09c-4.42 3.27-23.16 4.75-23.16 4.75s6.9-17.49 11.32-20.76a10 10 0 0 1 11.84 16z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M956.49 584.5s-24.15-4.83-30.59-11.27-35.42-17.71-38.64-9.66-43.47 35.42-16.1 40.25 64.4 6.44 72.44 3.22 12.89-22.54 12.89-22.54z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M871.17 600.83c27.37 4.83 64.4 6.44 72.44 3.22 6.13-2.45 10.39-14.23 12.07-19.72l.81.17s-4.83 19.32-12.88 22.54-45.08 1.61-72.44-3.22c-7.9-1.39-10.16-4.67-9.31-8.81.68 2.7 3.43 4.78 9.31 5.82z",
    opacity: 0.2
  }));
};
UndrawDroneDelivery.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawDroneDelivery;